import { Box, Grid, styled } from '@mui/material';

export const CardActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1.5),
  paddingBottom: theme.spacing(1),
  paddingRight: theme.spacing(0),
  borderTop: `1px solid ${theme.palette.borders.light}`,
}));

export const CardActionsTop = styled(Box)({
  height: '28px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

export const CardActionsBottom = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  color: theme.palette.text.secondary,
  fontSize: 13,
}));

/**
 * A grid-view card cell whose `.overlay-section` and checkbox show on hover, focus or selection.
 */
export const SelectableGridItem = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  position: 'relative',

  width: '20%',
  [theme.breakpoints.down('sm')]: {
    flex: '0 0 100%',
    maxWidth: '100%',
  },
  '.overlay-section, .MuiCheckbox-root': {
    opacity: selected ? 1 : 0,
  },
  // focus-within too, or a keyboard user tabs onto an invisible checkbox
  '&:hover .overlay-section, &:hover .MuiCheckbox-root, &:focus-within .overlay-section, &:focus-within .MuiCheckbox-root':
    {
      opacity: 1,
    },
}));
